if (!window.customElements.get('measurement-chart-table')) {
  window.customElements.define(
    'measurement-chart-table',
    class MeasurementChartTable extends HTMLElement {
      connectedCallback() {
        this._abortController = new AbortController();

        this.querySelectorAll('button[data-unit]').forEach((button) => {
          button.addEventListener('click', () => this._setUnit(button.dataset.unit), {
            signal: this._abortController.signal
          });
        });
      }

      disconnectedCallback() {
        this._abortController.abort();
      }

      _setUnit(unit) {
        this.querySelectorAll('button[data-unit]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.unit === unit));
        });

        this.querySelectorAll('[data-cm]').forEach((cell) => {
          const centimeters = Number.parseFloat(cell.dataset.cm);

          if (Number.isNaN(centimeters)) {
            return;
          }

          cell.textContent = String(unit === 'in' ? Math.round((centimeters / 2.54) * 4) / 4 : centimeters);
        });
      }
    }
  );
}
